export default __webpack_public_path__ + "6a2a21b1ac72bc1c562cde33fec43e33.png";